var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"id":"cardRRHH"}},[_c('AccountsTable'),_c('CommunicatesSummary'),_c('CredentialsSummary'),_c('DeleteDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }